/**
 * @file AdUnitRowSlot.tsx
 *
 * @fileoverview Renders row ad unit.
 *  This ad banner occupied the full width.
 */

import { HideDesktop } from '~/vcl/atoms/06-layout/02-visibility/01-hide-desktop';
import { HideMobile } from '~/vcl/atoms/06-layout/02-visibility/02-hide-mobile';
import styles from './adUnits.module.scss';

interface AdUnitRowSlotProps {
  row: {
    bundle?: string;
    adUnitId?: string;
  };
}

export default function AdUnitRowSlot({
  row: { bundle, adUnitId },
}: AdUnitRowSlotProps) {
  return (
    <>
      <HideDesktop>
        <div
          id="traffective-ad-Mobile_Pos2"
          style={{ display: 'none' }}
          className={`Mobile_Pos2 ${styles.adUnitBillboard}`}
        ></div>
      </HideDesktop>
      <HideMobile>
        <div
          id="traffective-ad-Billboard"
          style={{ display: 'none' }}
          className={`Billboard ${styles.adUnitBillboard}`}
        ></div>
      </HideMobile>
    </>
  );
}

export { AdUnitRowSlot };
